import {
  ContentIndexTypeEnum,
  ContentTypeEnum,
  IStaticContext,
  IStaticData,
  TitleLevelEnum,
} from "@/static/dataType";
import sampleCode from "../../../public/static/sdk-sample/code-sample";

const SDK_URL = process.env.VUE_APP_SDK_URL;
const data: Array<IStaticData> = [
  {
    title: {
      text: "SDK(JavaScript)でストリーミング再生を行う",
    },
    children: [
      {
        title: {
          text: "想定ケース",
          level: TitleLevelEnum.second,
          hasBorder: true,
        },
        content: [
          {
            text: "自社のWebサービスに映像を埋め込みたい",
            indexType: ContentIndexTypeEnum.circle,
          },
        ],
      },
      {
        title: {
          text: "サンプルコード",
          level: TitleLevelEnum.second,
          hasBorder: true,
        },
        content: [
          {
            type: ContentTypeEnum["code-sample"],
            styleObject: { marginLeft: "0", width: "100%" },
            codes: {
              pcList: [
                {
                  label: "JavaScript",
                  name: "javascript",
                  content: sampleCode.JAVASCRIPT_CONTENT,
                },
                {
                  label: "CSS",
                  name: "css",
                  content: sampleCode.CSS_CONTENT,
                },
                {
                  label: "HTML",
                  name: "html",
                  content: sampleCode.HTML_CONTENT(SDK_URL as string),
                },
              ],
              pcMaxWidth: "100%",
              pcWidth: "100%",
              spList: [
                {
                  label: "JavaScript",
                  name: "javascript",
                  content: sampleCode.JAVASCRIPT_CONTENT,
                },
                {
                  label: "CSS",
                  name: "css",
                  content: sampleCode.CSS_CONTENT,
                },
                {
                  label: "HTML",
                  name: "html",
                  content: sampleCode.HTML_CONTENT(SDK_URL as string),
                },
              ],
              spMaxWidth: "100%",
              spWidth: "100%",
            },
          },
        ],
      },
      {
        title: {
          text: "デモ",
          level: TitleLevelEnum.second,
          hasBorder: true,
        },
        content: [
          {
            type: ContentTypeEnum["demo-video"],
            styleObject: { marginLeft: "0", width: "100%" },
          },
        ],
      },
      {
        title: {
          text: "サンプルコードの利用方法",
          level: TitleLevelEnum.second,
          hasBorder: true,
        },
        content: [
          {
            text: "サンプルコードはサイトに埋め込んでご利用ください。埋め込み後の動作確認手順は以下になります。同ページのデモからもお試しいただけます。",
          },
        ],
      },
      {
        title: {
          text: "APIキー認証をご利用の場合",
          level: TitleLevelEnum.third,
        },
        content: [
          {
            text: "<a href='/tutorial/api-key' class='is-static-link' target='_blank'>APIキー認証について</a>を参考に、APIキー認証アプリケーションを作成しAPIキーを発行してください。アプリケーション作成の際には、利用SDKにPlayer、Devicesにチェックを入れてください。",
            indexType: ContentIndexTypeEnum.index,
            type: ContentTypeEnum.link,
            indexText: "1.",
          },
          {
            text: "<a href='/tutorial/api-key' class='is-static-link' target='_blank'>APIキー認証について</a>の「APIキーとデバイスの紐付け」をご参考に、サンプルに表示したいデバイスをAPIキーに紐づけを行ってください。ディベロッパーアカウントがオーナーアカウントではないデバイスを紐づけたい場合は審査が必要になります。詳しくは<a href='/faq?path=0-0-2' class='is-static-link' target='_blank'>こちら</a>をご確認ください",
            indexType: ContentIndexTypeEnum.index,
            type: ContentTypeEnum.link,
            indexText: "2.",
          },
          {
            text: "Set Tokenをクリック（タップ）し、作成したAPIキーをセットしてください。",
            indexType: ContentIndexTypeEnum.index,
            indexText: "3.",
          },
          {
            text: "load devicesをクリック（タップ）し、映像を表示したいデバイス名を選択してください。",
            indexType: ContentIndexTypeEnum.index,
            indexText: "4.",
          },
          {
            text: "add playerをクリック（タップ）してください。",
            indexType: ContentIndexTypeEnum.index,
            indexText: "5.",
          },
        ],
      },
      {
        title: {
          text: "OAuth2.0認証をご利用の場合",
          level: TitleLevelEnum.third,
        },
        content: [
          {
            text: "<a href='/tutorial/oauth' class='is-static-link' target='_blank'>OAuth2.0認証について</a>を参考に、OAuth2.0認証アプリケーションを作成しClientIDを発行してください。アプリケーション作成の際には、利用SDKにPlayer、Devicesにチェックを入れてください。",
            indexType: ContentIndexTypeEnum.index,
            type: ContentTypeEnum.link,
            indexText: "1.",
          },
          {
            text: "<a href='/tutorial/oauth' class='is-static-link' target='_blank'>OAuth2.0認証について</a>の「認可コードの取得」「アクセストークン/リフレッシュトークンの取得」をご参考にアクセストークンを取得してください。",
            indexType: ContentIndexTypeEnum.index,
            type: ContentTypeEnum.link,
            indexText: "2.",
          },
          {
            text: "Set Tokenをクリック（タップ）し、作成したアクセストークンをセットしてください。",
            indexType: ContentIndexTypeEnum.index,
            indexText: "3.",
          },
          {
            text: "load devices をクリック（タップ）し、映像を表示したいデバイス名を選択してください。",
            indexType: ContentIndexTypeEnum.index,
            indexText: "4.",
          },
          {
            text: "add playerをクリック（タップ）してください。",
            indexType: ContentIndexTypeEnum.index,
            indexText: "5.",
          },
        ],
      },
      {
        title: {
          text: "注意点",
          level: TitleLevelEnum.second,
          hasBorder: true,
        },
        content: [
          {
            text: "自社サーバーに映像を取り込みたい場合は、ストリーミング APIをご利用ください。",
            type: ContentTypeEnum.link,
            indexType: ContentIndexTypeEnum.circle,
          },
          {
            text: "制約事項は<a href='/terms-of-api/sdk' class='is-static-link' target='_blank'>SDK(JavaScript)の機能制約</a>をご参照ください。",
            type: ContentTypeEnum.link,
            indexType: ContentIndexTypeEnum.circle,
          },
        ],
      },
    ],
  },
];

const context: IStaticContext = {
  headerTitle: "SDK設計ガイドライン",
  headerIcon: require("./images/header-icon.svg"),
  data,
};
export default context;
